module.exports = __webpack_public_path__ + "img/bg_logistics.07b567c2.svg";